import React from 'react';
import { useSearchParams } from 'react-router-dom';
import classes from './tabs.module.scss';

function Tabs(props) {
  const { children, tabs, currentTab, setTab } = props;

  const [searchParams, setSearchParams] = useSearchParams();

  const changeTab = (tab) => {
    setSearchParams({ ...Object.fromEntries(searchParams.entries()), tab: tab.value });
    setTab(tab);
  };

  return (
    <div className={classes.container}>
      <div className={classes.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab.value}
            aria-hidden="true"
            className={`${tab.value !== currentTab.value ? '' : classes.active} ${classes.tab}`}
            onClick={() => changeTab(tab)}
          >
            {tab.title}{' '}
            {(tab?.badgeText || tab?.badgeText === 0) && <span className={classes.count}>{tab.badgeText}</span>}{' '}
          </div>
        ))}
      </div>
      <hr className={classes.divider} />
      {children}
    </div>
  );
}

export default Tabs;
